// Homework to do
export const setHomeworkTodo = (dispatch, userId, todo) =>
  dispatch({ type: "SET_TODO", userId, todo });

// Homework
export const setSelectedHomework = (dispatch, id, userId) =>
  dispatch({ type: "SELECT_HOMEWORK", id, userId });
export const setHomework = (dispatch, id, userId, homework) =>
  dispatch({ type: "SET_HOMEWORK", id, userId, homework });

// Milestone
export const setMilestoneValidation = (dispatch, id, userId) =>
  dispatch({ type: "VALIDATE_MILESTONE", id, userId });
export const setMilestone = (dispatch, id, userId, milestone) =>
  dispatch({ type: "SET_MILESTONE", id, userId, milestone });

// List edition
export const createList = (dispatch, userId) => dispatch({ type: "CREATE_LIST", userId });
export const editList = (dispatch, listId) => dispatch({ type: "CREATE_LIST", listId });
export const closeCreateList = (dispatch) => dispatch({ type: "CLOSE_CREATE_LIST" });

// Homework edition
export const createHomework = (dispatch, listId, userId) =>
  dispatch({ type: "CREATE_HOMEWORK", listId, userId });
export const editHomework = (dispatch, homeworkId, userId) =>
  dispatch({ type: "CREATE_HOMEWORK", homeworkId, userId });
export const closeCreateHomework = (dispatch) => dispatch({ type: "CLOSE_CREATE_HOMEWORK" });

// Activities
export const setActivity = (dispatch, activity) => dispatch({ type: "SET_ACTIVITY", activity });
